<template>
  <v-card flat>
      <v-row class="py-0 my-0">
        <v-col cols="12" class="pa-1">
          <v-row>
            <v-col xs="6" md="4" lg="6">
              {{ $t('message.deviations.categories') }}
            </v-col>
            <v-col xs="6" md="4" lg="3">
              <v-select dense outlined :label="$t('message.datestrings.month')" v-model="categoryMonthFilter" :items="monthFilterList"
                item-text="text" item-value="value" @change="getDeviationCategoryDashboardData"></v-select>
            </v-col>
            <v-col xs="6" md="4" lg="3">
              <v-select dense outlined :label="$t('message.datestrings.year')" v-model="categoryYearFilter" :items="yearFilterList"
                @change="onYearFilterChange"></v-select>
            </v-col>
          </v-row>
          <v-card-text class="py-0 my-0">
            <highcharts :options="categoryChart" ref="categoryChart"></highcharts>
          </v-card-text>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <deviation-report :deviationReport="deviationReport" groupby="MONTH"></deviation-report>
        </v-col>
      </v-row>
    </v-card>
</template>
<script>
import moment from 'moment'
export default {
  data () {
    return {
      categoryChart: {
        chart: {
          height: 280,
          type: 'column'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: []
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t('message.order.qty'),
            align: 'high'
          },
          labels: {
            overflow: 'justify'
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
              '<td style="padding:0"><b>{point.y:.2f}</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true
            }
          }
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'top',
          x: -40,
          y: 80,
          floating: true,
          borderWidth: 1,
          backgroundColor: '#FFFFFF',
          shadow: true
        },
        credits: {
          enabled: false
        },
        series: []
      },
      categoryMonthFilter: 6,
      categoryYearFilter: moment().year(),
      deviationReport: []
    }
  },
  components: {
    'deviation-report': () => import('@/components/Reports/DeviationReport.vue')
  },
  computed: {
    monthFilterList () {
      return [{
        text: this.$t('message.datestrings.previousMonth'),
        value: 1
      }, {
        text: this.$t('message.datestrings.lastMonth', { month: 3 }),
        value: 3
      }, {
        text: this.$t('message.datestrings.lastMonth', { month: 6 }),
        value: 6
      }, {
        text: this.$t('message.datestrings.lastMonth', { month: 12 }),
        value: 12
      }]
    },
    yearFilterList () {
      const year = moment().year()
      let last5Years = []
      for (let index = 0; index < 5; index++) {
        last5Years.push(year - index)
      }
      return last5Years
    }
  },
  mounted () {
    this.getDeviationCategoryDashboardData()
    this.getDeviationReportData()
  },
  methods: {
    onYearFilterChange () {
      this.getDeviationCategoryDashboardData()
      this.getDeviationReportData()
    },
    getDeviationCategoryDashboardData () {
      const selectedYear = this.categoryYearFilter
      // Anchor to December of the selected year, or to today if it is the current year,
      // so that today's month does not bleed into calculations for past years.
      const anchorDate = selectedYear === moment().year()
        ? moment()
        : moment({ year: selectedYear, month: 11 })
      let tillDate = anchorDate.clone().endOf('month').format('YYYY-MM-DD')
      if (this.categoryMonthFilter === 1) {
        tillDate = anchorDate.clone().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
      }
      const fromDate = anchorDate.clone().subtract(this.categoryMonthFilter, 'months').startOf('month').format('YYYY-MM-DD')
      this.$_executeApi('get', `deviations/get_category_dashboard_view?fromDate=${fromDate}&tillDate=${tillDate}`)
        .then((response) => {
          if (response.data) {
            this.categoryChart.series = response.data.series
            this.categoryChart.xAxis.categories = response.data.categorylist
          }
        })
    },
    getDeviationReportData () {
      const fromDate = moment({ year: this.categoryYearFilter }).startOf('year').format('YYYY-MM-DD')
      const tillDate = moment({ year: this.categoryYearFilter }).endOf('year').format('YYYY-MM-DD')
      this.$_executeApi('post', 'deviations/get_deviation_report', { fromdate: fromDate, tilldate: tillDate, groupby: 'MONTH', categoryids: [], statusids: [], locationids: [] })
        .then((response) => {
          if (response.data) {
            this.deviationReport = response.data
          }
        })
    }
  }
}
</script>
